declare global {
	interface Window {
		/** Streaming SSR treatment for confluence_ssr_superbatch_recovery, fixed for this document. */
		__SSR_SUPERBATCH_RECOVERY_ENABLED__?: boolean;
	}
}

/** Direct consumers retain their existing content when treatment cannot bootstrap WRM. */
export function handleSuperbatchUnavailable(error: unknown): void {
	if (!isSuperbatchRecoveryEnabled()) {
		throw error;
	}
	// Treatment failures have already been recorded by the shared loader.
}

export const SUPERBATCH_RECOVERY_TIMEOUT_MS = 30_000;

export function isSuperbatchRecoveryEnabled(): boolean {
	// Reuse the server decision: a later client evaluation must not disagree with emitted scripts.
	return window.__SSR_SUPERBATCH_RECOVERY_ENABLED__ === true;
}

export function withSuperbatchRecoveryTimeout<T>(
	load: (signal: AbortSignal) => Promise<T>,
): Promise<T> {
	const controller = new AbortController();
	return new Promise((resolve, reject) => {
		const timeout = window.setTimeout(() => {
			reject(new Error('Superbatch loading timed out'));
			controller.abort();
		}, SUPERBATCH_RECOVERY_TIMEOUT_MS);
		try {
			void load(controller.signal).then(
				(value) => {
					window.clearTimeout(timeout);
					resolve(value);
				},
				(error: unknown) => {
					window.clearTimeout(timeout);
					controller.abort();
					reject(error);
				},
			);
		} catch (error) {
			window.clearTimeout(timeout);
			controller.abort();
			reject(error);
		}
	});
}
